import {
  API_ERROR,
  BASICUNIT,
  BASICUNIT_LIST_SUCCESSFUL,
  BASICUNIT_ADD,
  BASICUNIT_ADD_SUCCESSFUL,
  BASICUNIT_EDIT,
  BASICUNIT_EDIT_SUCCESSFUL,
  BASICUNIT_DELETE,
  BASICUNIT_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
} from "./actionTypes";

export const getBasicUnits = () => {
   return {
    type: BASICUNIT,
  };
};

export const BasicUnitListSuccessful = (BasicUnit) => {
  return {
    type: BASICUNIT_LIST_SUCCESSFUL,
    payload: BasicUnit,
  };
};

export const BasicUnitAdd = (BasicUnit, history) => {
   return {
    type: BASICUNIT_ADD,
    payload: { BasicUnit, history },
  };
};

export const BasicUnitAddSuccessful = (response) => {
   return {
    type: BASICUNIT_ADD_SUCCESSFUL,
    payload: response,
  };
};

export const BasicUnitEdit = (data) => {
  return {
    type: BASICUNIT_EDIT,
    payload: data,
  };
};

export const BasicUnitEditSuccessful = (response) => {
    return {
      type: BASICUNIT_EDIT_SUCCESSFUL,
      payload: response,
    };
  };

export const BasicUnitDelete = (BUId, history) => {
  return {
    type: BASICUNIT_DELETE,
    payload: { BUId, history },
  };
};

export const SetEditData = (data) => {
  return {
    type: BASICUNIT_SETROWDATA,
    payload: data,
  };
};

export const model_open = () => {
  return {
    type: MODEL_OPEN,
  };
};

export const model_close = () => {
  return {
    type: MODEL_CLOSE,
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
